import zyTrack from "zy-track/src"
const infoKey = "zhiyitech-track-common-info"

function reportCustom(event: string, content: Record<string, any> = {}) {
  const userInfo = sessionStorage.getItem(infoKey) ? JSON.parse(sessionStorage.getItem(infoKey)!) : {}
  zyTrack.reportCustom({
    appId: "plus-fd",
    event,
    ...userInfo,
    ...content,
  })
}

const registerInfo = (obj: Record<string, unknown>) => {
  const oldInfo = sessionStorage.getItem(infoKey) ? JSON.parse(sessionStorage.getItem(infoKey)!) : {}
  const newObj = { ...oldInfo, ...obj }
  sessionStorage.setItem(infoKey, JSON.stringify(newObj))
}

export default {
    registerInfo,
    reportCustom,
}